import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteMembership } from '../../../../_global/fragments/generated/CompleteMembership';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetResourceMembershipsQueryVariables = Types.Exact<{
  page: Types.PageInput;
  resourceId: Types.Scalars['ID']['input'];
  grantingResource: Types.GrantingResourceInput;
  locale?: Types.InputMaybe<Types.SupportedLocale>;
}>;


export type GetResourceMembershipsQuery = { __typename?: 'Query', indirectMemberships?: { __typename?: 'MembershipConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, type: string, grantingResource?: { __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum } | null, accountUserGroup?: { __typename?: 'AccountUserGroup', id: string, name?: string | null, memberCount?: number | null, accountId: string, emoji?: string | null } | null, userGroup?: { __typename?: 'AdobeManagedUserGroup', id: string, name?: string | null, memberCount?: number | null } | { __typename?: 'FrameManagedUserGroup', id: string, name?: string | null, memberCount?: number | null } | { __typename?: 'WorkfrontManagedUserGroup', id: string, name?: string | null, memberCount?: number | null } | null, accountUser?: { __typename?: 'AccountUser', accountUserType?: Types.AccountUserTypeEnum | null, avatarColor?: Types.AvatarColor | null, email?: string | null, id: string, inviteEmailAddress?: string | null, isPending: boolean, name?: string | null, profileImageUrl?: string | null, userId?: string | null, licenseType?: Types.AccountUserLicenseTypeValue | null } | null, role?: { __typename?: 'Role', description?: string | null, id: string, name: string, order?: number | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };


export const GetResourceMemberships = /*#__PURE__*/ gql`
    query GetResourceMemberships($page: PageInput!, $resourceId: ID!, $grantingResource: GrantingResourceInput!, $locale: SupportedLocale) {
  indirectMemberships(
    resourceId: $resourceId
    page: $page
    filter: {grantingResource: $grantingResource}
  ) {
    nodes {
      ...CompleteMembership
      grantingResource {
        id
        name
        resourceType
      }
      accountUserGroup {
        id
        name
        memberCount
      }
      userGroup {
        id
        name
        memberCount
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CompleteMembership}` as unknown as DocumentNode<GetResourceMembershipsQuery, GetResourceMembershipsQueryVariables>;

          

          export const useGetResourceMembershipsQuery = (options?:QueryHookOptions<GetResourceMembershipsQuery, GetResourceMembershipsQueryVariables>) => useQuery(GetResourceMemberships, options);

          

          export type GetResourceMembershipsQueryOptions = QueryHookOptions<GetResourceMembershipsQuery, GetResourceMembershipsQueryVariables>;

          

          export const useGetResourceMembershipsLazyQuery = (options?:LazyQueryHookOptions<GetResourceMembershipsQuery, GetResourceMembershipsQueryVariables>) => useLazyQuery(GetResourceMemberships, options);

          

          export type GetResourceMembershipsQueryResult = ReturnType<typeof useGetResourceMembershipsQuery>;

          
